var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" สิทธิ์การเข้าใช้งาน ")])}
var staticRenderFns = []

export { render, staticRenderFns }